import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectNotificationState = (state: RootState) =>
  state.notificationState;

export const selectNotifications = createSelector(
  selectNotificationState,
  (state) => state.notifications
);
